import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';

//import DocumentoEnvioService from '@services/DocumentoEnvioService';
//import CartaoService from '@services/CartaoService';
import Toast from '@base/Toast';

import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import Divider from '@material-ui/core/Divider';

import RotateRightOutlinedIcon from '@material-ui/icons/RotateRightOutlined';
import RadioButtonCheckedOutlinedIcon from '@material-ui/icons/RadioButtonCheckedOutlined';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import SortByAlphaOutlinedIcon from '@material-ui/icons/SortByAlphaOutlined';
import WallpaperOutlinedIcon from '@material-ui/icons/WallpaperOutlined';
import ContactsOutlinedIcon from '@material-ui/icons/ContactsOutlined';
import FormatShapesIcon from '@material-ui/icons/FormatShapes';
import StarHalfOutlinedIcon from '@material-ui/icons/StarHalfOutlined';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import DialpadOutlinedIcon from '@material-ui/icons/DialpadOutlined';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import ButtonPrimary from "../../base/Button/Button";
import useStyles from './Style';
import CartaoService from '@services/CartaoService';
export const VisualizadorDeArquivo = props => {

  const [file, setFile] = useState('');
  const classes = useStyles();
  const estilo = props.estilo;
  //const tipo = props.tipo;
  //const idDocumento = props.idDocumento;
  const toastRef = useRef(null);
  //const [botaoIlegivel, setBotaoLegivel] = useState('');
  const blob = props.blob;
  const [rotation, setRotation] = useState(0);
  const [totalClicks, setTotalClicks] = useState(0);

  /*const submit = () => {

    switch (tipo) {
      case 'de':
        DocumentoEnvioService.ilegivel(idDocumento).then(arquivo => {
          mensagem('Documento de Envio', arquivo);
        });
        break;
      case 'cartao':
        CartaoService.ilegivel(idDocumento).then(arquivo => {
          mensagem('Cartão', arquivo);
        });
        break;
      default:
    }

  }*/

  /*const mensagem = (tipoArquivo, arquivo) => {
    toastRef.current.show("warning", `${tipoArquivo} foi marcado com ilegível!`);
    setBotaoLegivel(arquivo.data.arquivoLegivel);
  };*/

  const blobToBase64 = (blob) => {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  const carregaArquivo = useCallback(() => {

    if (blob)
      blobToBase64(blob).then(arquivo => {
        setFile(arquivo);
      });
  }, [blob]);

  useEffect(() => carregaArquivo(), [carregaArquivo]);

  const handleImageClick = () => {
    setTotalClicks(totalClicks + 1);
    setRotation((prevRotation) => prevRotation + 90);
  };

  const salvarRotacao = () => {

    CartaoService.girar(props.cartaoId, totalClicks).then(arquivo => {
      setTotalClicks(0);
    });

  }

  const rotateCursor =
    `url("data:image/svg+xml;utf8,` +
    encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="128" height="48" viewBox="0 0 128 48">
      <!-- fundo leve para contraste -->
      <rect x="1" y="1" width="126" height="46" rx="8" fill="white" fill-opacity="0.92" stroke="#111" stroke-width="1.5"/>

      <!-- ícone de girar (esquerda) -->
      <g transform="translate(6,8) scale(1.15)">
        <path
          fill="#111111"
          d="M15.55 5.55 11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42 1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
        />
      </g>

      <!-- texto "Clique p/ Girar" centralizado na área direita -->
      <text
        x="78"
        y="27"
        font-family="Arial, Helvetica, sans-serif"
        font-size="12"
        font-weight="700"
        fill="#111111"
        text-anchor="middle"
      >Clique p/ Girar</text>
    </svg>
  `) +
    `") 12 24, pointer`;


  const renderizaDocumento = (type) => {

    if (type.includes('image')) {
      return (
        <img
          alt="" src={file}
          onClick={!props.rotate && handleImageClick}
          width={'100%'} height={'100%'}
          className={classes.rotate}
          style={{ transform: `rotate(${rotation}deg)`, cursor: rotateCursor}}
        />
      );
    } else if (type.includes('application/pdf')) {

      return (
        <Document file={file}>
          <Page pageNumber={1} />
        </Document>
      );
    }

    return <></>;
  };


  return (
    <>
      <Toast ref={toastRef} />
      <div className={estilo ? classes.top : ""}>
        {(props.blob && props.blob.size > 0 && props.ilegivel) &&
          <Alert severity="warning">O arquivo abaixo se encontra ilegível!</Alert>
        }

        {(props.blob && props.blob.size > 0 && props.linkCorte) &&
          <>
            <div className={classes.actions}>
              <Rodar rodar={handleImageClick} />

              <Divider className={classes.dividerButtons} orientation="vertical" flexItem />

              <Corte type="original" name="Cartão Inteiro" icon={<WallpaperOutlinedIcon />} link={props.linkCorte} cut={false} />
              <Corte type="escritos" name="Texto" icon={<SortByAlphaOutlinedIcon />} link={props.linkCorte} />
              <Corte type="bolinhas" name="Marcações" icon={<RadioButtonCheckedOutlinedIcon />} link={props.linkCorte} />
              <Corte type="nome" name="Nome" icon={<FormatShapesIcon />} link={props.linkCorte} />
              <Corte type="data" name="Data de Nascimento" icon={<EventOutlinedIcon />} link={props.linkCorte} />
              <Corte type="ddd" name="DDD" icon={<LocationOnOutlinedIcon />} link={props.linkCorte} />
              <Corte type="telefone" name="Telefone" icon={<DialpadOutlinedIcon />} link={props.linkCorte} />
              <Corte type="cpf" name="CPF" icon={<ContactsOutlinedIcon />} link={props.linkCorte} />
              <Corte type="email" name="Email" icon={<AlternateEmailIcon />} link={props.linkCorte} />
              <Corte type="nota" name="Nota" icon={<StarHalfOutlinedIcon />} link={props.linkCorte} />
            </div>

            <Divider />
          </>
        }

        {file && renderizaDocumento(props.blob.type)}

        {totalClicks > 0 && props.cartaoId ? <ButtonPrimary
          onClick={() => salvarRotacao()}
          name="Salvar Rotação"
        /* disabled={loading} */
        /> : <></>}

      </div>
    </>
  );
}

export const Rodar = ({ rodar }) => {
  const classes = useStyles();

  return (
    <Tooltip title="Rodar 90° para a Direita" TransitionComponent={Zoom}>
      <IconButton
        color="primary"
        size="small"
        style={{ marginLeft: '3px', marginRight: '3px' }}
        className={classes.actionsButtons}
        aria-label="Rodar 90° para a Direita"
        onClick={rodar}
      >
        <RotateRightOutlinedIcon />
      </IconButton>
    </Tooltip>
  )
}

export const Corte = ({ type, name, icon, link, cut = true }) => {
  const classes = useStyles();

  return (
    <Tooltip title={cut ? `Ver Corte de ${name}` : `${name}`} TransitionComponent={Zoom}>
      <IconButton
        color="primary"
        size="small"
        className={classes.actionsButtons}
        aria-label={cut ? `Ver Corte de ${name}` : `${name}`}
        onClick={() => window.open(`${process.env.REACT_APP_CDN_URL}/${link}/${type}.jpg`, "", `width=1024, height=${cut ? `512` : `768`}, menubar=no, toolbar=no, location=no, status=no`)}
      >
        {icon}
      </IconButton>
    </Tooltip>
  )
}

export function montarLinkCorte(codigo, objetoPostal, tokenArquivo) {
  return codigo && objetoPostal && tokenArquivo ? `${objetoPostal}/${codigo}/${tokenArquivo}` : null;
}

export default VisualizadorDeArquivo;
